import { AlertTriangle, HelpCircle, X } from 'lucide-react';

export interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Sitenin kendi tasarım diliyle onay diyaloğu — native window.confirm()/alert()
 * yerine. `danger` true olduğunda (silme, sınıftan çıkarma gibi geri alınamaz
 * işlemler) onay butonu kırmızıdır.
 */
export function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = 'Onayla',
  cancelLabel = 'Vazgeç',
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-surface border border-border rounded-2xl p-6 max-w-md w-full space-y-5 shadow-2xl relative text-text-primary">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <div
              className={`w-10 h-10 shrink-0 rounded-xl flex items-center justify-center ${
                danger ? 'bg-danger-100 text-danger-500' : 'bg-accent-100 text-accent-600'
              }`}
            >
              {danger ? <AlertTriangle size={20} /> : <HelpCircle size={20} />}
            </div>
            <div>
              <h2 className="text-base font-bold text-text-primary tracking-tight">{title}</h2>
              <p className="text-xs text-text-secondary font-medium mt-1 leading-relaxed">{message}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="p-1 rounded-full text-text-muted hover:text-text-primary transition-colors shrink-0"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex items-center justify-end gap-2 pt-1">
          <button type="button" onClick={onCancel} className="bitmiyo-btn bitmiyo-btn-outline text-xs px-4 py-2">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={
              danger
                ? 'bitmiyo-btn text-xs px-4 py-2 bg-danger-500 hover:bg-danger-600 text-white'
                : 'bitmiyo-btn bitmiyo-btn-primary text-xs px-4 py-2'
            }
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
